import windStationsAPI from '../common/api/windStations';

const windStationsReducer = { path: windStationsAPI.reducerPath, reducer: windStationsAPI.reducer };

export default windStationsReducer;
